const SwichComponent = ({width,active,setActive}) => {
    return (
        <div onClick={()=>{setActive(!active)}} className = {`w-[40px] p-1 mt-4  flex cursor-pointer ${active ? 'justify-end  bg-[#478DF8]' : 'justify-start  bg-[#343B4F]'} rounded-[10px]`}>
            <div className="p-2 rounded-[100%] bg-[white]"></div>
        </div>
    )
}

export default SwichComponent